import script from "./datatable.vue?vue&type=script&setup=true&lang=js"
export * from "./datatable.vue?vue&type=script&setup=true&lang=js"

import "./datatable.vue?vue&type=style&index=0&id=a2017d8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2017d8c"]])

export default __exports__